import ModalDialog from 'components/modal-dialog.dev';

function DefaultDialog(options = {}) {
    ModalDialog.call(this, {
        header: 'Спасибо!',
        message: 'Ваша заявка на персональный подбор жилья отправлена.<br> Мы свяжемся с вами в ближайшее время.',
        autoClose: false,
        useSuccessButton: true,
        ...options,
    });
}

DefaultDialog.prototype = Object.create(ModalDialog.prototype);
Object.defineProperty(DefaultDialog.prototype, 'constructor', {
    value: DefaultDialog,
    enumerable: false,
    writable: true,
});

export default DefaultDialog;